import '.b4{border-radius:1.25rem;}.ssr-plugin'
import '.c{overflow:hidden;}.ssr-plugin'
import '.gx{border:var(--border-default);}.ssr-plugin'
import '.gy{min-height:420px;}.ssr-plugin'
import '.c7{height:100%;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  return (
    <styled.div className={`${className} b4 c gx gy c7 l m`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
